import React from 'react';

export const VideoUploadIcon = () => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="2"
        y="2"
        width="32"
        height="32"
        rx="16"
        fill="#1974C7"
        fill-opacity="0.1"
      />
      <rect
        x="2"
        y="2"
        width="32"
        height="32"
        rx="16"
        stroke="#1974C7"
        stroke-opacity="0.1"
        strokeWidth="4"
      />
      <g clip-path="url(#clip0_750_7797)">
        <path
          d="M18.0002 24.6673V11.334M14.6668 24.6673V21.334M14.6668 14.6673V11.334M21.3335 24.6673V21.334M21.3335 14.6673V11.334M11.3335 14.6673H24.6668M11.3335 21.334H24.6668M24.6668 21.4673V14.534C24.6668 13.4139 24.6668 12.8538 24.4488 12.426C24.2571 12.0497 23.9511 11.7437 23.5748 11.552C23.147 11.334 22.5869 11.334 21.4668 11.334L14.5335 11.334C13.4134 11.334 12.8533 11.334 12.4255 11.552C12.0492 11.7437 11.7432 12.0497 11.5515 12.426C11.3335 12.8538 11.3335 13.4139 11.3335 14.534L11.3335 21.4673C11.3335 22.5874 11.3335 23.1475 11.5515 23.5753C11.7432 23.9516 12.0492 24.2576 12.4255 24.4493C12.8533 24.6673 13.4134 24.6673 14.5335 24.6673H21.4668C22.5869 24.6673 23.147 24.6673 23.5748 24.4493C23.9511 24.2576 24.2571 23.9516 24.4488 23.5753C24.6668 23.1475 24.6668 22.5874 24.6668 21.4673Z"
          stroke="#1974C7"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_750_7797">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(10 10)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
